import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { IWorkbookAccelerationInfo } from '../models/IWorkbookAccelerationInfo';
import { GetWorkbookAccelerationsRequest } from '../ServerApi/requests/GetWorkbookAccelerationsRequest';
import { IListResource } from './Resource';
import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from './ResourceQuery';

export class WorkbookAccelerationsResource implements IListResource<IWorkbookAccelerationInfo> {

  private listFetcher = new WebClientListResourceFetcher(GetWorkbookAccelerationsRequest, ServerApiMapper.workbookAccelerations);

  public all(): ResourceQuery<IWorkbookAccelerationInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const WorkbookAccelerations = new WorkbookAccelerationsResource();
